// styled.js
import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../../../../../../constants/colors';

export const SpotifyPreviewCard = styled.div`
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline')
      ? 'transparent'
      : theme?.card_color || '#1c1c1c'};
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '10px' :
      theme?.card_style?.includes('squared') ? '0' : '15px'};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline')
      ? `2px solid ${theme?.card_color || '#000'}`
      : 'none'};
  overflow: hidden;
  color: ${({ theme }) => theme?.card_text_color || 'white'};
  width: 100%;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s ease;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  
  &:hover {
    transform: scale(1.02);
  }
  
  &.button-layout {
    width: 100%;
    padding: 10px;
    height: 75px;
    display: flex;
    padding-right: 15px;
    align-items: center;
  }
  
  &.highlight-layout {
    aspect-ratio: 1/1;
    display: block;
    overflow: visible;
  }
`;

export const AnimatedSpotifyPlayer = styled.div`
   max-height: ${({ show }) => (show ? '600px' : '0px')};
   opacity: ${({ show }) => (show ? '1' : '0')};
   transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out;
   overflow: hidden;
 `;

export const SpotifyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  padding-right: 15px;
  background-color: inherit;
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '10px' :
    theme?.card_style?.includes('squared') ? '0' : '15px'};

  .spotify-logo {
    width: 28px;
    height: 28px;
  }
`;

export const SpotifyContent = styled.div`
  padding: ${props => props.layout === 'button' ? '0' : '0'};
  display: flex;
  flex-direction: ${props => props.layout === 'button' ? 'row' : 'column'};
  align-items: center;
  gap: 12px;
  width: 100%;

  &.highlight-layout {
    text-align: center;
    
    img {
      width: ${({ isArtist }) => (isArtist ? '50%' : '65%')};
      height: auto;
      border-radius: 12px;
     
      @media (min-width: 768px) {
        width: ${({ isArtist }) => (isArtist ? '60%' : '70%')};
      }
    }
  }

  &.button-layout {
    justify-content: center;
    
    .button-image {
      width: 55px;
      height: 55px;
      border-radius: 10px;
      object-fit: cover;
    }
  }
`;

export const ArtistImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
`;

export const ArtistInfo = styled.div`
  flex: 1;
  text-align: ${props => props.layout === 'button' ? 'center' : 'center'};
  
  .artist-type {
    font-size: ${props => props.layout === 'button' ? '14px' : '24px'};
    font-weight: 700;
    margin: 0;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }

  .artist-name {
    font-size: ${props => props.layout === 'button' ? '12px' : '16px'};
    color: ${({ theme }) => theme?.card_text_color || '#b3b3b3'};
    margin-top: 4px;
    opacity: 0.7;
  }

  .button-name {
    font-size: 14px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }
`;

export const ProductCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '10px' :
      theme?.card_style?.includes('squared') ? '0' : '15px'};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? `2px solid ${theme?.card_color || '#000'}` : 'none'};
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? 'transparent' : theme?.card_color || '#1c1c1c'};

  .product-content {
    display: flex;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .product-info {
    flex-grow: 1;
    padding-left: 15px;
    text-align: left;

    h3, p {
      color: ${({ theme }) => theme?.card_text_color || 'white'};
      margin: 0;
    }

    p {
      margin-top: 4px;
      opacity: 0.7;
    }
  }

  .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 10px;
    overflow: hidden;
  }

  .product-button {
    margin-top: auto;
    width: 100%;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    text-decoration: none;
    border-radius: ${({ theme }) =>
    theme?.button_style?.includes('slightly-rounded') ? '10px' :
      theme?.button_style?.includes('squared') ? '0' : '15px'};
    background-color: ${({ theme }) => theme?.button_color || COLORS.$mainBlue};
    color: ${({ theme }) => theme?.button_text_color || '#FFFFFF'};
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  .button-text {
    flex-grow: 1;
    text-align: left;
    color: ${({ theme }) => theme?.button_text_color || '#FFFFFF'};
  }

  .button-icon {
    margin-left: 10px;
    display: flex;
    align-items: center;
    
    svg path {
      stroke: ${({ theme }) => theme?.button_text_color || '#FFFFFF'};
    }
  }

  .ant-card-body {
    padding: 0;
    width: 100%;
  }
`;

const getShadowStyle = (theme) => {
  if (!theme?.shadow_color) return '0 4px 8px rgba(0, 0, 0, 0.1)';

  const hexToRgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const softShadowColor = hexToRgba(theme.shadow_color, 0.1);
  const hardShadowColor = hexToRgba(theme.shadow_color, 0.5);

  switch (theme?.card_style) {
    case 'soft-shadow-squared':
    case 'soft-shadow-slightly-rounded':
      return `0 6px 12px ${softShadowColor}`;
    case 'hard-shadow-squared':
    case 'hard-shadow-slightly-rounded':
      return `3px 3px 0 ${hardShadowColor}`;
    case 'outline-squared':
    case 'outline-slightly-rounded':
      return 'none';
    default:
      return `0 4px 8px ${softShadowColor}`;
  }
};